import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import default styles
import './emailPanel.css'; // Import custom dark theme styles
import { adminApi } from '../../api';


export default function SendEmailPanel(props) {
  const [csvEmails, setCsvEmails] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailContent, setEmailContent] = useState('');
  const [sendDate, setSendDate] = useState(null); // Initialize as null

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevents the default form submission behavior

    // Validate that sendDate is selected
    if (!sendDate) {
      alert('Please select a send date and time.');
      return;
    }

    const payload = {
      csvEmails,
      emailSubject,
      emailContent,
      sendDate: sendDate.toISOString(), // Convert to ISO string for consistency
    };

    console.log('Payload:', payload);

    try {
      const response = await adminApi.post('/admin/email/request_admin_emails', payload);
      console.log('Emails sent successfully:', response.data);

      // // Clear the form fields after successful submission
      // setCsvEmails('');
      // setEmailSubject('');
      // setEmailContent('');
      // setSendDate(null);
    } catch (error) {
      console.error('Error sending emails:', error);
      alert('Failed to send emails. Please try again.');
      // Optionally, handle errors here (e.g., show a notification)
    }
  };

  return (
    <div className="max-w-5xl text-left text-gray-100">
      <h2 className="mb-5 text-lg font-semibold">Send Email</h2>
      <form onSubmit={handleSubmit}>
        {/* Date and Time Picker */}
        <div className="mb-4">
          <label htmlFor="sendDate" className="block text-gray-300 mb-2">
            Send Date & Time:
          </label>
          <DatePicker
            selected={sendDate}
            onChange={(date) => setSendDate(date)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="MMMM d, yyyy h:mm aa"
            className="w-full p-2 border border-gray-600 rounded bg-gray-700 text-gray-100"
            placeholderText="Select date and time"
            required
          />
        </div>

        {/* CSV Emails */}
        <div className="mb-4">
          <label htmlFor="csvEmails" className="block text-gray-300 mb-2">
            CSV Emails:
          </label>
          <textarea
            id="csvEmails"
            className="w-full p-2 mb-4 border border-gray-600 rounded bg-gray-800 text-gray-100"
            placeholder="Add CSV emails"
            rows="3"
            value={csvEmails}
            onChange={(e) => setCsvEmails(e.target.value)}
            required
          />
        </div>

        {/* Email Subject */}
        <div className="mb-4">
          <label htmlFor="emailSubject" className="block text-gray-300 mb-2">
            Subject:
          </label>
          <input
            type="text"
            id="emailSubject"
            className="w-full p-2 border border-gray-600 rounded bg-gray-800 text-gray-100"
            placeholder="Email Subject"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
            required
          />
        </div>

        {/* Email Content */}
        <div className="mb-4">
          <label htmlFor="emailContent" className="block text-gray-300 mb-2">
            Content:
          </label>
          <ReactQuill
            value={emailContent}
            onChange={setEmailContent}
            className="bg-gray-800 text-gray-100"
            style={{ height: '300px' }} // Increased height for more rows
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit" // Specifies the button as a submit type
          className="bg-blue-500 text-white mt-4 mb-4 py-2 px-4 rounded hover:bg-blue-600 transition-colors"
        >
          Submit
        </button>
      </form>
    </div>
  );
}
